import { useEffect, useState, useRef, useContext, createContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import styles from "./Hub.module.css"
import guestii from '../../assets/images/logos/guestii.svg'
import guestii_gif from '../../assets/images/guestii_gif.gif'
import temp_qr from '../../assets/images/temp_qr.svg'
import { MovingTimeContainer } from '../Utils/Helpers'


const LockoutPage = ({ formData, handleForm, newAddress, setSelected, selected, handleOpen, setPlusOnes, plusOnes, isLoading }) => {
	const [page, setPage] = useState(1)
	const [validationError, setValidationError] = useState(null)


	const pageValidator = (checks ) => {
		let checked = []

		for (const check of checks) {
			const input = check.input
			const label = check.label
			const condition = check.condition
			const passedVar = check.var
			const formValue = formData[input]


			switch (condition) {
				case 'isSet':
				case 'isChecked':
					if (formValue && formValue !== "") {
						checked.push({
							input: input,
							success: true
						})
					} else {
						checked.push({
							input: input,
							success: false,
							msg: `Please ${condition === "isSet" ? "enter" : "select"} the ${label}.`
						})
					}
					break;
			}
		}

		return checked
	}

	const handleControls = (control) => {
		switch (control) {
			case 'submit':
				var checks = [
      				{
      					input: 'lockout_time', 
      					label: 'lockout time',
      					condition: 'isSet'
      				}
  				]

				var checked = pageValidator(checks)
				var errors = checked.filter(check => !check.success)

				if (errors.length > 0) {
					setValidationError(errors[0].msg)
				} else {
					setValidationError(null)
					handleForm('submit')
				}

				break;
			case 'prev':
				setPage(page - 1)
				break;
		}
	}

	return (
		<div className={`${styles.popup_container} ${isLoading && styles.popup_setheight}`}>
			{!isLoading
				?
					<div className={styles.lockout_layout}>
						<button className={styles.ind_close} onClick={() => handleOpen('close')}><i className={`fa-solid fa-xmark ${styles.s1}`}></i></button>

						<div className={styles.new_banner}>
							<div className={styles.new_title}>
								<p className={styles.bold}>Set Event Lockout</p>
								<p className={styles.s1}>Close scanning at a particular time.</p>
							</div>

							<div className={styles.banner_progress}>
								<div className={`${styles.progress_circle} ${page >= 1 && styles.progress_circle_active}`}>
									<i className={`fa-solid fa-clock ${styles.m1}`}></i>
								</div>
							</div>
						</div>

						{page === 1 && <LockoutModule { ... { formData, handleForm, newAddress } }/>}
						{validationError && <div className={styles.errorMsg}><p className={styles.s1}>{validationError}</p></div>}

						<FormControls {... { handleControls, page, handleForm, formData } }/>
					</div>
				:
			        <div className={styles.loading_layout}>
			            <img src={guestii_gif}/>
			        </div>
			}
		</div>
	)
}

const LockoutModule = ({ formData, handleForm, newAddress }) => {
	return (
		<div className={styles.nevent_form_container}>
			<div className={styles.lockout_warning}>
				<p className={styles.s1}>Use this module to lock Guestii's out of your event at a particular time. This will send them a notification alert.</p>
			</div>

			<MovingTimeContainer
				label={"Lockout Time"}
				handleForm={handleForm}
				formData={formData}
			/>
		</div>
	)
}


const FormControls = ({ handleControls, page, handleForm, formData }) => {
	return (
		<div className={styles.control_container}>
			<button className={`${styles.control_btn} ${styles.next_btn}`} onClick={() => handleControls('submit')}>
				<i className={`fa-solid fa-check ${styles.m1}`}></i>
			</button>
		</div>
	)
}


const Lockout = ({ handleOpen, tempFormData = null }) => {
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);
	const [isAuthenticated, setIsAuthenticated] = useState(true);
	const [formData, setFormData] = useState({})


	useEffect(() => {
	    const handleLoad = async () => {
	    	setIsLoading(true)

	      	if (tempFormData) {
	        	setFormData({ ...tempFormData, event_name: tempFormData.name });
	      	}

	      	setIsLoading(false)
	    };

	    handleLoad();
	}, []);

	const handleForm = async (control, label, input) => {
		switch (control) {
			case 'set':
				let labelFormatted = label.replaceAll(" ", "_").toLowerCase()

				if (input) {
					if (input.target && input.target.files) {
						setFormData((prev) => ({...prev, [labelFormatted]: input.target.files[0] }))
					} else if (input.target) {
						setFormData((prev) => ({...prev, [labelFormatted]: input.target.value }))
					} else {
						setFormData((prev) => ({...prev, [labelFormatted]: input }))
					}
				}
				break;
			case 'submit':
				const userId = localStorage.getItem("_id")
				if (!userId) {
					window.location = "/connect"
				}

				let response;
				try {
					setIsLoading(true)

					response = await axios.post(`/api/hub/event-lockout/${userId}`, {
						lockoutTime: formData.lockout_time,
						eventId: formData._id
					});

				} catch (e) {
					console.log(e)
					localStorage.removeItem("_id")
					window.location = "/connect"
				}


    			const state = { from: response.data.newEvent };
    			sessionStorage.setItem('navigationState', JSON.stringify(state));
    			window.location.reload()
    			setIsLoading(false)
				break;
		}
	}

	return (
		<LockoutPage {... { formData, handleForm, handleOpen, isLoading } }/>
	);
};

export default Lockout;